import { useEffect } from "react";
const drafts = new Map<symbol, boolean>();
let routerGuards = 0;
export function registerDraftRouterGuard() {
  routerGuards += 1;
  return () => {
    routerGuards -= 1;
  };
}
export function hasUnsavedDraft() {
  return drafts.size > 0;
}
export function hasUnknownDraft() {
  return [...drafts.values()].some(Boolean);
}
export function confirmDraftDiscard() {
  return window.confirm("This draft is not saved. Discard it and leave?");
}
function unload(event: BeforeUnloadEvent) {
  if (!drafts.size) return;
  event.preventDefault();
  event.returnValue = "";
}
function navigate(event: MouseEvent) {
  if (!drafts.size || !(event.target instanceof Element)) return;
  const destination = event.target.closest("a[href], [data-draft-exit]");
  if (!destination) return;
  if (
    destination instanceof HTMLAnchorElement &&
    destination.origin !== window.location.origin
  )
    return;
  if (destination instanceof HTMLAnchorElement && routerGuards > 0) return;
  const locked = hasUnknownDraft();
  if (locked || !confirmDraftDiscard()) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}
/** Keep drafts in the current account/context; browser storage never holds their contents. */
export function useUnsavedDraft(dirty: boolean, unknown = false) {
  useEffect(() => {
    if (!dirty && !unknown) return;
    const token = Symbol("draft");
    drafts.set(token, unknown);
    window.addEventListener("beforeunload", unload);
    document.addEventListener("click", navigate, true);
    return () => {
      drafts.delete(token);
      if (!drafts.size) {
        window.removeEventListener("beforeunload", unload);
        document.removeEventListener("click", navigate, true);
      }
    };
  }, [dirty, unknown]);
}
